import type { AdminPolicyDocument, CrudActionType as CrudActionName, FieldAction, PolicyDocument } from '#layers/access';
import { crudActions, fieldActions } from '#layers/access';

// Re-export constants for backwards compatibility
export { allPolicyDocumentActions, policyFieldRuleActions, policyItemRuleAction } from '#layers/access';

export function isFieldRulesAction(action: CrudActionName): action is FieldAction {
	return (fieldActions as readonly string[]).includes(action);
}

export function isItemRulesAction(action: CrudActionName): action is CrudActionName {
	return (crudActions as readonly string[]).includes(action);
}

export function isAdminPolicyDocument(policy: PolicyDocument): policy is AdminPolicyDocument {
	return policy.access === 'admin';
}
